/** Keep only unidentified CDS attempts in checkout; persisted operations use purchase follow-up. */
export default function keepsCdsPointsCheckout(
  usesCdsPoints,
  purchaseStatus,
  pointsUsed,
  redemptionId,
) {
  return (
    usesCdsPoints === true &&
    !['completed', 'canceled'].includes(purchaseStatus) &&
    !(Number(pointsUsed) > 0) &&
    !redemptionId
  );
}
